import React, { useCallback, useEffect, useRef, useState } from "react";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { commonService } from "../../../../utils/commonService";
import downArrow from "../../../../Assets/Images/Header/downArrow.svg";
import Loader from "../../../Loader/Loader";
import { Chart } from "chart.js/auto";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { errorToastMessage } from "../../../../utils/toastMessage";
import { useSelector } from "react-redux";
import Comments from "../Comments/Comment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useParams } from "react-router-dom";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import emailIcon from "../../../../Assets/Images/Email.svg";
import moment from "moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const MarketSegmentDrilldownChart = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const widgetDetailRef = useRef();
    const [widgetModal, setWidgetModal] = useState(false);
    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const [settingData, setSettingData] = useState("Market Segment");

    const [loading, setLoading] = useState(false);
    const [chartDataNew, setChartDataNew] = useState(false);
    const [marketSegmentData, setMarketSegmentData] = useState(null);
    const [tableData, setTableData] = useState(null);
    const [marketSegmentName, setMarketSegmentName] = useState(null);
    const [rateCodeName, setRateCodeName] = useState(null);
    const [companyName, setcompanyName] = useState(null);
    useEffect(() => {
        if (marketSegmentName) {
            GetFilteredData(marketSegmentName, rateCodeName, companyName);
        }
    }, [marketSegmentName, rateCodeName, companyName]);
    const date = new Date();

    const startDate = commonService.getDateInDBFormat(
        date.setDate(date.getDate() - 6)
    );
    const endDate = commonService.getDateInDBFormat(new Date());
    const [stayStartDate, setStayStartDate] = useState(new Date(startDate));
    const [stayEndDate, setStayEndDate] = useState(new Date(endDate));
    const [analyticData, setAnalyticData] = useState(null);
    const lineChartDataRef = useRef([]);
    const [filter, setFilter] = useState({
        occ: 0,
        rate: 0,
    });
    const [chart_y_axis_valueNew, setchart_y_axis_valueNew] = useState(0);
    const [chart_x_axis_valueNew, setchart_x_axis_valueNew] = useState(0);
    const maxYAxisRefNew = useRef();
    const maxRateAxisRefNew = useRef();
    const [lineChartDataNew, setLineChartDataNew] = useState([]);

    const getNewSWOTData = async () => {
        setLoading(true);
        try {
            let chartDataResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.MARKET_SEGMENT.SWOT_ANALYSIS,
                    body: {
                        asofdate: para?.asOfDate,
                        startdate: commonService.getDateForNode(stayStartDate),
                        enddate: commonService.getDateForNode(stayEndDate),
                        propertycode: para?.propertyCode,
                    },
                },
                false
            );

            let response = apiResponse(false, chartDataResponse);
            if (response?.isValidate) {
                setMarketSegmentData(response?.data?.data);

                setLoading(false);
            }
        } catch (error) { }
    };

    const GetDropSelectionData = (name) => {
        let data = [];
        if (name === "Market Segment") {
            data = marketSegmentData?.filter(
                (x) =>
                    x.marketsegment !== null &&
                    x.ratecode === null &&
                    x.company === null &&
                    x.guestname === null
            );
        } else if (name === "Rate Code") {
            data = marketSegmentData?.filter(
                (x) => x.ratecode !== null && x.company === null && x.guestname === null
            );
        } else if (name === "Company") {
            data = marketSegmentData?.filter(
                (x) => x.company !== null && x.guestname === null
            );
        } else if (name === "Clients") {
            data = marketSegmentData?.filter((x) => x.guestname !== null);
        }

        if (data?.length > 0) {
            let a_x =
                parseInt(
                    Math.max(...data?.map((item) => parseInt(item?.weightedoccperc || 0)))
                ) + 10;
            let a_y =
                parseInt(
                    Math.max(...data?.map((item) => parseInt(item?.avgadr || 0)))
                ) + 10;
            let newArr = [];

            data?.forEach((item) => {
                let obj = {};
                obj.type = "bubble";
                obj.label =
                    name === "Market Segment"
                        ? item?.marketsegment
                        : name === "Rate Code"
                            ? item?.ratecode
                            : name === "Company"
                                ? item?.company
                                : item?.guestname;
                obj.backgroundColor = commonService.CreateColor(
                    name === "Market Segment"
                        ? item?.marketsegment
                        : name === "Rate Code"
                            ? item?.ratecode
                            : name === "Company"
                                ? item?.company
                                : item?.guestname
                )?.BGColor;
                obj.data = [
                    {
                        id: commonService.GenerateGUID(),
                        x: parseInt(item?.avgadr),
                        y: parseInt(item?.weightedoccperc),
                        r: (item?.weightedoccperc * 50) / a_x,
                        meta: item,
                    },
                ];
                // if (item.weightedoccperc > max_x) {
                //   max_x = item.weightedoccperc;
                // }
                // if (item.avgadr > max_y) {
                //   max_y = item.avgadr;
                // }
                newArr.push(obj);
            });
            setchart_y_axis_valueNew(a_x);
            setchart_x_axis_valueNew(a_y);
            maxYAxisRefNew.current = a_x;
            maxRateAxisRefNew.current = a_y;
            // return newArr;
            setChartDataNew(newArr);
        }
    };

    const GetFilteredData = (
        marketsegment = null,
        ratecode = null,
        company = null
    ) => {
        let data = [];
        if (marketsegment) {
            data = marketSegmentData?.filter(
                (x) =>
                    x.marketsegment === marketsegment &&
                    x.ratecode !== null &&
                    x.company === null &&
                    x.guestname === null
            );
            if (ratecode) {
                data = marketSegmentData?.filter(
                    (x) =>
                        x.marketsegment === marketsegment &&
                        x.ratecode === ratecode &&
                        x.company !== null &&
                        x.guestname === null
                );
            }
            if (company) {
                data = marketSegmentData?.filter(
                    (x) =>
                        x.marketsegment === marketsegment &&
                        x.ratecode === ratecode &&
                        x.company === company &&
                        x.guestname !== null
                );
            }
        } else {
            data = marketSegmentData?.filter(
                (x) => x.company === null && x.ratecode === null && x.guestname === null
            );
        }

        let a_x =
            parseInt(
                Math.max(...data.map((item) => parseInt(item?.weightedoccperc || 0)))
            ) + 10;
        let a_y =
            parseInt(Math.max(...data.map((item) => parseInt(item?.avgadr || 0)))) +
            10;
        let newArr = [];

        data?.forEach((item) => {
            let obj = {};
            obj.type = "bubble";
            obj.label =
                marketsegment && !ratecode
                    ? item?.ratecode
                    : ratecode && !company
                        ? item?.company
                        : company
                            ? item?.guestname
                            : item?.marketsegment;
            obj.backgroundColor = commonService.CreateColor(
                marketsegment && !ratecode
                    ? item?.ratecode
                    : ratecode && !company
                        ? item?.company
                        : company
                            ? item?.guestname
                            : item?.marketsegment
            )?.BGColor;
            obj.data = [
                {
                    id: commonService.GenerateGUID(),
                    x: parseInt(item?.avgadr),
                    y: parseInt(item?.weightedoccperc),
                    r: (item?.weightedoccperc * 50) / a_x,
                    meta: item,
                },
            ];
            // if (item.weightedoccperc > max_x) {
            //   max_x = item.weightedoccperc;
            // }
            // if (item.avgadr > max_y) {
            //   max_y = item.avgadr;
            // }
            newArr.push(obj);
        });

        setchart_y_axis_valueNew(a_x);
        setchart_x_axis_valueNew(a_y);
        maxYAxisRefNew.current = a_x;
        maxRateAxisRefNew.current = a_y;
        // return newArr;
        setChartDataNew(newArr);
    };

    useEffect(() => {
        if (api === 0) {
        } else {
            if (para?.asOfDate) {
                getNewSWOTData();
            }
        }
    }, [para?.asOfDate]);

    const GetTableData = (data) => {
        let result = [];
        const findOrCreate = (arr, key, value, rest) => {
            let node = arr.find((item) => item[key] === value);
            if (!node) {
                node = { ...rest, data: [] };
                arr.push(node);
            }
            return node;
        };
        data.forEach((item) => {
            // ---- LEVEL 1: Market Segment ----
            if (
                item.marketsegment &&
                !item.ratecode &&
                !item.company &&
                !item.guestname
            ) {
                let segNode = findOrCreate(
                    result,
                    "marketsegment",
                    item.marketsegment,
                    item
                );

                // ---- LEVEL 2: Rate Code ----
                data.forEach((rc) => {
                    if (
                        rc.ratecode &&
                        rc.marketsegment === item.marketsegment &&
                        !rc.company &&
                        !rc.guestname
                    ) {
                        let rateNode = findOrCreate(
                            segNode.data,
                            "ratecode",
                            rc.ratecode,
                            rc
                        );

                        // ---- LEVEL 3: Company ----
                        data.forEach((comp) => {
                            if (
                                comp.company &&
                                comp.marketsegment === item.marketsegment &&
                                comp.ratecode === rc.ratecode &&
                                !comp.guestname
                            ) {
                                let compNode = findOrCreate(
                                    rateNode.data,
                                    "company",
                                    comp.company,
                                    comp
                                );

                                // ---- LEVEL 4: Guest ----
                                data.forEach((guest) => {
                                    if (
                                        guest.guestname &&
                                        guest.marketsegment === item.marketsegment &&
                                        guest.ratecode === rc.ratecode &&
                                        guest.company === comp.company
                                    ) {
                                        findOrCreate(
                                            compNode.data,
                                            "guestname",
                                            guest.guestname,
                                            guest
                                        );
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        setTableData(result);
    };

    useEffect(() => {
        if (marketSegmentData) {
            GetFilteredData();
            GetTableData(marketSegmentData);
        }
    }, [marketSegmentData]);

    const drawCrossLine = async () => {
        let firstLineChartData = {
            type: "line",
            label: "",
            data: [],
            borderColor: "rgb(210, 210, 210)",
            backgroundColor: "rgb(210, 210, 210)",
            fill: false,
            borderWidth: 3,
            pointRadius: 0,
            pointHoverRadius: 0,
        },
            secondLineChartData = {
                type: "line",
                label: "",
                data: [],
                borderColor: "rgb(210, 210, 210)",
                backgroundColor: "rgb(210, 210, 210)",
                fill: false,
                borderWidth: 3,
                pointRadius: 0,
                pointHoverRadius: 0,
            };

        let occArr = [],
            occValue = 0;
        for (let i = 0; occValue < maxYAxisRefNew.current; i++) {
            occArr.push(occValue);
            occValue = occValue + 10;
        }

        occValue = occValue - 10;
        if (maxYAxisRefNew.current > occValue) {
            occArr.push(occValue + 10);
        }
        occArrRef.current = occArr;

        let occFilterValue = filter?.occ;
        let newObj1 = { ...firstLineChartData };
        for (let i = 0; occFilterValue < maxYAxisRefNew.current; i++) {
            newObj1.data.push({ x: 10 * i, y: occFilterValue });
            occFilterValue = occFilterValue + 10;
        }

        occFilterValue = occFilterValue - 10;
        if (maxYAxisRefNew.current > occFilterValue) {
            newObj1.data.push({
                x: newObj1.data[newObj1.data?.length - 1]?.x + 10,
                y: occFilterValue + 10,
            });
        }
        firstLineChartData = { ...newObj1 };

        let rateAxisData = 0,
            rateArr = [];
        for (let i = 0; rateAxisData < maxRateAxisRefNew.current; i++) {
            rateArr.push(10 * i);
            rateAxisData = rateAxisData + 10;
        }

        rateAxisData = rateAxisData - 10;
        if (maxRateAxisRefNew.current > rateAxisData) {
            rateArr.push(rateArr[rateArr?.length - 1] + 10);
        }
        rateArrRef.current = rateArr;

        let rateValue = filter?.rate;
        let newObj = { ...secondLineChartData };
        let findRemainingPoint = rateArrRef.current?.filter(
            (x) => x > filter?.rate
        );
        let findGap = Math.round(
            firstLineChartData?.data[firstLineChartData?.data?.length - 1]?.y /
            findRemainingPoint?.length
        );
        let gapValue = findGap;
        for (
            let i = 0;
            rateValue <= rateArrRef.current[rateArrRef.current?.length - 1];
            i++
        ) {
            if (i === 0) {
                newObj.data.push({ x: rateValue, y: 0 });
            } else {
                if (
                    firstLineChartData?.data[firstLineChartData?.data?.length - 1]?.y >=
                    gapValue
                ) {
                    newObj.data.push({ x: rateValue, y: gapValue });
                } else {
                    newObj.data.push({
                        x: rateValue,
                        y: firstLineChartData?.data[firstLineChartData?.data?.length - 1]
                            ?.y,
                    });
                }

                gapValue = gapValue + findGap;
            }
            rateValue = rateValue + 10;
        }
        secondLineChartData = { ...newObj };
        // }

        lineChartDataRef.current = [firstLineChartData, secondLineChartData];
        setLineChartDataNew(lineChartDataRef.current);
    };
  
    const showMoreLegendRef = useRef(false); 
    const [showMoreLegend, setShowMoreLegend] = useState(false); 
    const DEFAULT_VISIBLE_LEGENDS = 5; 
    const chartInstanceRef = useRef(null);
    
    const drawChart = () => {
    if (!chartDataNew || lineChartDataNew?.length === 0) return;

    const ctx = document.getElementById("marketSegmentWiseReservation");
    if (!ctx) return;

    if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
    }

    chartInstanceRef.current = new Chart(ctx, {
        type: "bubble",
        data: {
        datasets: [...chartDataNew],
        },
        options: {
        responsive: true,

        scales: {
            x: {
            title: { display: true, text: "RATE" },
            suggestedMin: 0,
            suggestedMax: chart_x_axis_valueNew,
            ticks: {
                callback: (v) =>
                `${propertyDetailFromRTK?.currency_term || "$"}${v}`,
            },
            },
            y: {
            title: { display: true, text: "WEIGHTED OCCUPANCY %" },
            suggestedMin: 0,
            suggestedMax: chart_y_axis_valueNew,
            ticks: {
                callback: (v) => `${v}%`,
            },
            },
        },

        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        var occValue = context.raw.y;
                        var rateValue = context.raw.x;
                        return (
                            `${marketSegmentData && settingData}` +
                            (marketSegmentName !== null
                                ? ` : ${marketSegmentName}`
                                : "") +
                            (marketSegmentName !== null ? " | Rate Code" : "") +
                            (rateCodeName !== null ? ` : ${rateCodeName}` : "") +
                            (rateCodeName !== null ? ` | Company` : "") +
                            (companyName !== null ? ` : ${companyName}` : "") +
                            (companyName !== null ? ` | Clients` : "") +
                            `: ${context.dataset.label} | Weighted Occupancy: ${occValue}% | Rate:$${rateValue} `
                        );
                    },
                },
            },
            legend: {
            display: false, // ✅ IMPORTANT
            },
        },
        },
    });

    generateScrollableLegend(chartInstanceRef.current);
    };
    
    const generateScrollableLegend = (chart) => {
    if (!chart) return;

    const legendContainer = document.getElementById("chart-legend");
    if (!legendContainer) return;

    legendContainer.innerHTML = "";
    const ul = document.createElement("ul");

    chart.data.datasets.forEach((dataset, index) => {
        if (!dataset?.data?.length) return;

        if (
        !showMoreLegendRef.current &&
        index >= DEFAULT_VISIBLE_LEGENDS
        ) {
        return;
        }

        const li = document.createElement("li");

        // 🔹 CHECKED / UNCHECKED STATE
        if (!chart.isDatasetVisible(index)) {
        li.classList.add("legend-hidden");
        }

        const box = document.createElement("span");
        box.style.backgroundColor = dataset.backgroundColor;

        const text = document.createTextNode(dataset.label);

        li.appendChild(box);
        li.appendChild(text);

        li.onclick = () => {
        const isVisible = chart.isDatasetVisible(index);
        chart.setDatasetVisibility(index, !isVisible);
        chart.update();

        // 🔹 update legend UI instantly
        li.classList.toggle("legend-hidden", isVisible);
        };

        ul.appendChild(li);
    });

    legendContainer.appendChild(ul);
    };

    useEffect(() => {
    drawChart();

    return () => {
        chartInstanceRef.current?.destroy();
        chartInstanceRef.current = null;
    };
    }, [chartDataNew, filter, lineChartDataNew]);

    const toggleLegend = () => {
    const nextValue = !showMoreLegendRef.current;

    showMoreLegendRef.current = nextValue;
    setShowMoreLegend(nextValue);

    generateScrollableLegend(chartInstanceRef.current);
    };


    useEffect(() => {
        if (chartDataNew) {
            drawCrossLine();
        }
    }, [filter, chartDataNew]);

    const handleStayDateChange = (dates) => {
        const [start, end] = dates;
        setStayStartDate(start);
        setStayEndDate(end ? end : "");
    };

    const [tblids, settblids] = useState({
        // reservationanalytics: commonService.GenerateGUID(),
        marketsegmentwise: commonService.GenerateGUID(),
    });

    const occArrRef = useRef();
    const rateArrRef = useRef();

    const [expanded, setExpanded] = useState(() => new Set());
    const getLabel = (item, level) =>
        level === 0
            ? item.marketsegment
            : level === 1
                ? item.ratecode
                : level === 2
                    ? item.company
                    : item.guestname;
    const makeKey = (parentKey, level, item) =>
        `${parentKey}|${level}:${getLabel(item, level) ?? "NULL"}`;
    const toggle = (key) =>
        setExpanded((prev) => {
            const next = new Set(prev);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    const renderRows = (items, level = 0, parentKey = "root") =>
        items.flatMap((item) => {
            const key = makeKey(parentKey, level, item);
            const children = Array.isArray(item.data) ? item.data : [];
            const hasChildren = children.length > 0;
            const isExpanded = expanded.has(key);

            return [
                <tr key={key} className={`level-${level}`}>
                    {/* FIRST column only: indent + caret + label */}
                    <td id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "td-onclick", item)} className="border_right first-col" onClick={() => toggle(key)}>
                        <span className="hier-label" style={{ marginLeft: level * 16 }}>
                            {getLabel(item, level)}
                        </span>
                        {hasChildren && (
                            <button
                                type="button"
                                className="expander"
                                aria-label={isExpanded ? "Collapse" : "Expand"}
                            >
                                {isExpanded ? <img src={downArrow} /> : <img src={downArrow} />}
                            </button>
                        )}
                    </td>

                    {/* Keep these columns aligned; no padding-left here */}
                    <td className="border_right text-center">
                        {item?.weightedoccperc != null ? `${item.weightedoccperc}%` : ""}
                    </td>
                    <td className="border_right text-center">{item?.occ ?? ""}</td>
                    <td className="text-end">
                        {item?.avgadr != null ? `$${item.avgadr}` : ""}
                    </td>
                </tr>,
                ...(isExpanded ? renderRows(children, level + 1, key) : []),
            ];
        });

    const { snapshottitle, propertyCode, snapshotId } = useParams();
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );

    useEffect(() => {
        GetDropSelectionData(settingData);
    }, [settingData]);
    return (
        <div className="widget-container" style={{ position: "relative" }}>
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button className="heading-menu-btns" type="button" title="Send Mail">
                        <img id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.marketsegmentwise,
                                    "Market Segment Drill Down",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.MarketSegmentDrilldownChart,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.marketsegmentwise}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.marketsegmentwise,
                                    // "Day By Day Channel"
                                    `${para?.propertyCode}-Market Segment Drill Down-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <Row>
                <div style={{ display: "flex", gap: "10px" }}>
                    <div className="form-groups from-groups no-border-break meghaDatePicker width225">
                        <Form.Label>Stay Date</Form.Label>
                        <DatePicker id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "stay-date", propertyCode)}
                            portalId="datepicker-root"
                            onChange={handleStayDateChange}
                            startDate={stayStartDate}
                            endDate={stayEndDate}
                            selectsRange
                            monthsShown={2}
                        />
                    </div>
                    <div className="marign-condition-btn">
                        <button id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "search", propertyCode)}
                            className="default-btn primary-btn"
                            onClick={() => {
                                if (!stayStartDate || !stayEndDate) {
                                    return errorToastMessage("Please select start & end date");
                                }
                                // getAnalyticsChartData();
                                getNewSWOTData();
                            }}
                        >
                            Search
                        </button>
                    </div>
                </div>
            </Row>
            <div className="mt-3">
                <Row>
                    <Col xl={2}>
                        {" "}
                        <div className="from-groups no-border-break mb-3">
                            <Form.Label>Forecast Type</Form.Label>
                            <Form.Select id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "forecast-type", propertyCode)}
                                aria-label="Default select example"
                                value={settingData}
                                onChange={(e) => {
                                    setSettingData(e.target.value);
                                    setMarketSegmentName(null);
                                    setRateCodeName(null);
                                    setcompanyName(null);
                                }}
                            >
                                <option key={"Market Segment"} value="Market Segment">
                                    {"Market Segment"}
                                </option>
                                <option key={"Rate Code"} value="Rate Code">
                                    {"Rate Code"}
                                </option>
                                <option key={"Company"} value="Company">
                                    {"Company"}
                                </option>
                                <option key={"Clients"} value="Clients">
                                    {"Clients"}
                                </option>
                            </Form.Select>
                        </div>
                    </Col>
                    <Col xl={10} className="mt-4">
                        {" "}
                        <div>
                            <span id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "span-onclick", propertyCode)}
                                style={{ cursor: "pointer", color: "#3565FC" }}
                                onClick={() => {
                                    setMarketSegmentName(null);
                                    setRateCodeName(null);
                                    setcompanyName(null);
                                    GetFilteredData();
                                    setSettingData("Market Segment");
                                }}
                            >
                                {marketSegmentData && marketSegmentName && "Market Segment"}
                            </span>
                            {marketSegmentName && ` : ${marketSegmentName}`}
                            <span id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "span-onclick", propertyCode)}
                                style={{ cursor: "pointer", color: "#3565FC" }}
                                onClick={() => {
                                    setRateCodeName(null);
                                    setcompanyName(null);
                                }}
                            >
                                {marketSegmentName && " | Rate Code"}
                            </span>
                            {rateCodeName && ` : ${rateCodeName}`}
                            <span id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "span-onclick", propertyCode)}
                                style={{ cursor: "pointer", color: "#3565FC" }}
                                onClick={() => {
                                    // setMarketSegmentName(null);
                                    // setRateCodeName(null);
                                    setcompanyName(null);
                                }}
                            >
                                {rateCodeName && ` | Company`}
                            </span>
                            {companyName && ` : ${companyName}`}
                            <span style={{ color: "#3565FC" }}>
                                {companyName && ` | Clients`}
                            </span>
                        </div>
                    </Col>
                </Row>
            </div>

            {loading ? (
                <Loader />
            ) : chartDataNew ? (
                <>
               <canvas id="marketSegmentWiseReservation"></canvas>
                <div id="chart-legend" className="chart-legend-scroll"></div>
                <button id={commonService.generateGlobalClickTrackerID("MarketSegmentDrilldownChart", "button-onclick", propertyCode)} onClick={toggleLegend} className="legend-toggle-btn">
                    {showMoreLegend ? "Show Less" : "Show More"}
                </button>
                </>
            ) : (
                <div>
                    <p>No Data Found</p>
                </div>
            )}

            <div class="col-xl-12 mt-3">
                <div class="generalTermSetup-heading">
                    <h2>Market Segment Wise</h2>
                </div>
            </div>
            <div className="ViewPropertySetupTable ">
                <div className="stripped__table">
                    <div className="table-responsive tblDynamicPickupSticky">
                        <Table
                            id={tblids.marketsegmentwise}
                            className="table-with-spacing positionStaticTable dailySummaryTbl myTable"
                        >
                            <colgroup>
                                <col style={{ width: "60%" }} />
                                <col style={{ width: "14%" }} />
                                <col style={{ width: "13%" }} />
                                <col style={{ width: "13%" }} />
                            </colgroup>
                            <thead className="tbl-header-sticky">
                                <tr className="table-main-header-tr">
                                    <th className="border_right">Market Segment</th>
                                    <th className="border_right text-center">Weighted Occ%</th>
                                    <th className="border_right text-center">RMS</th>
                                    <th className="text-end">ADR</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr style={{ height: "80px", position: "relative" }}>
                                        <Loader />
                                    </tr>
                                ) : tableData?.length ? (
                                    renderRows(tableData)
                                ) : (
                                    <tr>
                                        <td>No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            {api !== 0 && (
                <Comments
                    widgetDetails={para}
                    editorId={"MarketSegmentDrilldownChart"}
                />
            )}

            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
        </div>
    );
};

export default MarketSegmentDrilldownChart;
